import { FC, useEffect } from 'react';
import CandidateCard from './CandidateCard/CandidateCard';
import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';
import { CandidateWithAge } from '~/definitions/candidate';

interface Props {
    candidates: CandidateWithAge[];
}

const CandidateList: FC<Props> = (props: Props) => {
    const { candidates } = props;

    return (
        <div className="candidate-list bg-custom-grey-1 pb-[15px] pt-0">
            <div className="container-fluid">
                <div className="card-list flex flex-wrap justify-between">
                    {candidates.map((person) => (
                        <CandidateCard key={person.id} data={person} />
                    ))}
                </div>
            </div>
        </div>
    );
};

const CandidateListWithStore = () => {
    const { candidateStore, voteStore } = getStore();
    const candidates = candidateStore.candidates;

    useEffect(() => {
        voteStore.setInitialVoteData();
    }, [voteStore]);

    return <CandidateList candidates={candidates} />;
};

export default observer(CandidateListWithStore);
